import React from 'react';

export default function TitleDivision(props) {
    return (
        <div style={{fontSize:18,borderLeft:'3px solid #8A90FF',paddingLeft:10,marginBottom:10}}>{props.children}</div>
    );
}



// WEBPACK FOOTER //
// ./src/components/TitleDivision.js